import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Dropdown } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { getAuditAsync, getAuditExpenseEntriesAsync,  updateAuditPagination,  updatePagination , updateSorting } from "./AccountAuditSlice";
import { KTIcon, KTSVG, useDebounce } from '../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../common/Pagination";
import { paginationStyles, sortData } from "../../common/timeLiveFunction";
import { getPageSizeArray } from "../../common/timeLiveFunction";
import { getAndSetCustomFieldValues, formatCurrntDateTime, FormatInvoiceDecimalNumber, formatDateWithDateAndMonthName, getFilteredList, getValueFromResource } from "../../common/timeLiveFunction";
import AccountAuditItem from "./AccountAuditItems";
import Loader from "../../common/Loader";
import { getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync} from "../expense/expenseSlice";
import moment from "moment";
import clsx from "clsx";
import CanvasLoader from "../../common/CanvasLoader";
import PageSizeSelect from '../../common/PageSizeSelect';
import fetchAPI from '../../common/fetchAPI';

interface SelectedObjectType {
    Id: any;
    TableName: string;
    Title: string;
}

const ExpenseAudit = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { accountAuditList, expenseAuditList, isReload,sortOrder, sortColumn, search, pageNo, pageSize, isLoading , auditPageNo, auditPageSize, auditSearch} = useAppSelector((state) => state.audit);
    const { decimalPlaces, cultureInfoName, pageId, menuList, maxMenuHeight, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const { expenseEntryList, DecimalPlaces } = useAppSelector((state) => state.expense);
    const [selectedObject, setSelectedObject] = useState<SelectedObjectType | null>(null);
    const [showModal, setShowModal] = useState(false);
    // const [pageSize, setPageSize] = useState(10);
    const [pageSizesheet, setPageSizesheet] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    const [currentPagesheet, setCurrentPagesheet] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [searchTermSheet, setSearchTermSheet] = useState('');
    const location = useLocation();
    const { obj } = location.state || {};
    document.title = obj.Title + ` | Livetecs`;
    const [isLoader, setIsLoader] = useState(true);

    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const [customFieldsArrayForSheet, SetCustomFieldsArrayForSheet] = useState<any | ''>([]);
    // useEffect(() => {
    //     if (isReload) {
    //         dispatch(getAuditAsync({ TableName: obj.TableName, Id: obj.Id }));
    //         dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(obj.Id));
    //     }
    // }, [isReload])

    const getMasterEntityTypeId = (tableName: string) => {
        switch (tableName) {
            case "AccountParty":
                return 'E448AED9-EAB5-4CF7-A171-2A86BE2BBA9E';
            case "AccountEmployeeExpenseSheet":
                return 'A55DF02B-FBFB-4873-B582-6968FBAEE589';
            case "AccountExpenseEntry":
                return '756E4460-A713-4BEE-B3F0-708FC5BE21BD';
            case "AccountProjectTask":
                return 'C9A8F7F1-1B2D-48DA-AAE9-74F92892A896';
            case "AccountEmployee":
                return '3601AE9B-3F82-4C80-9574-751F9A124FA8';
            case "AccountProject":
                return '13DBFF37-A092-4AE2-A919-775CBED0EDC0';
            case "AccountEmployeeTimeEntryPeriod":
                return '369ED0FB-D317-4244-9F20-B7D834521E2B';
        }
    }

    const detectValueType = (value: any) => {
        if (!value || value === '') return 'TEXT';

        const strValue = String(value).trim();
        if (strValue === 'true' || strValue === 'false') {
            return 'BOOLEAN';
        }

        const datetimePattern = /\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/;
        if (datetimePattern.test(strValue)) {
            return 'DATETIME';
        }

        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (datePattern.test(strValue)) {
            return 'DATE';
        }

        if (!isNaN(parseFloat(value)) && isFinite(value) &&
            !/[a-zA-Z]/.test(strValue) &&
            strValue !== '0' && strValue !== '1') {
            return 'NUMERIC';
        }

        return 'TEXT';
    };

    const formatAuditValue = (value: any, cultureInfoName: any, decimalPlaces: any, fieldName: any) => {
        console.log("formatAuditValue fieldName value", fieldName, value)

        const name = fieldName ? fieldName.toString() : '';

        if (name.endsWith('Id') || name.endsWith('ID')) {
            return value;
        }

        let valueType = detectValueType(value);

        if (name.startsWith('Is')) {
            valueType = 'BOOLEAN';
        }

        if (name.includes('Amount')) {
            valueType = 'NUMERIC';
        }

        if (name.includes('Date')) {
            if (/\d{4}-\d{2}-\d{2}/.test(String(value))) {
                valueType = 'DATE';
            } else {
                valueType = 'TEXT';
            }
        }

        switch (valueType) {
            case 'BOOLEAN':
                const strVal = String(value).toLowerCase();
                return (strVal === '1' || strVal === 'true')
                    ? getValueFromResource('Yes', dispatch, t)
                    : getValueFromResource('No', dispatch, t);

            case 'DATETIME':
                return formatCurrntDateTime(value, cultureInfoName.toString());

            case 'DATE':
                return formatDateWithDateAndMonthName(value, cultureInfoName.toString());

            case 'NUMERIC':
                return FormatInvoiceDecimalNumber(cultureInfoName.toString(), value, decimalPlaces);

            case 'TEXT':
            default:
                return getValueFromResource(value, dispatch, t);
        }
    };

    const setCustomFieldValues = (databaseFieldName: string, value: any) => {
        if (value === null || value === undefined || value === '' || value === 'NaN' || String(value).toLowerCase() === 'nan') {
            return '';
        }const field = customFieldsArray.find(
            (item: any) => item.DatabaseFieldName === databaseFieldName
        );
        if (!field) {
            return value;
        }
        switch (field.MasterCustomDataTypeName) {
            case 'Number':
                const numValue = parseFloat(value);
                if (isNaN(numValue)) {
                    return '';
                }
                return FormatInvoiceDecimalNumber(
                    cultureInfoName.toString(),
                    numValue,
                    decimalPlaces
                );
            case 'Date':
                return formatDateWithDateAndMonthName(
                    value,
                    cultureInfoName.toString()
                );
            default:
                return value;
        }
    };

    useEffect(() => {
        dispatch(getAuditAsync({ TableName: obj.TableName, Id: obj.Id }));
        dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(obj.Id));
    }, [dispatch])

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async (MasterEntityTypeId: any) => {

        try {
            const response = await fetchAPI(
                'api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId,
                'GET',
                '',
                true,
                ""
            );
            const json = await response.json();
            if (MasterEntityTypeId === 'A55DF02B-FBFB-4873-B582-6968FBAEE589') {
                if (json.length > 0) {
                    SetCustomFieldsArrayForSheet(json);
                } else {
                    SetCustomFieldsArrayForSheet([]);
                }
            } else if (MasterEntityTypeId === '756E4460-A713-4BEE-B3F0-708FC5BE21BD') {
                if (json.length > 0) {
                    SetCustomFieldsArray(json);
                } else {
                    SetCustomFieldsArray([]);
                }
            }
            return json;
        } catch (error) {
            if (MasterEntityTypeId === 'A55DF02B-FBFB-4873-B582-6968FBAEE589') {
                SetCustomFieldsArrayForSheet([]);
            } else if (MasterEntityTypeId === '756E4460-A713-4BEE-B3F0-708FC5BE21BD') {
                SetCustomFieldsArray([]);
            }
        }
    }    

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync(
            '756E4460-A713-4BEE-B3F0-708FC5BE21BD'
        ).then(() => {
            getCustomFieldTemplateByMasterEntityTypeIdAsync(
                'A55DF02B-FBFB-4873-B582-6968FBAEE589'
            );
        });
    }, []);
    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    const handlePageChangeSheet = (pageNumber: any) => {
        setCurrentPagesheet(pageNumber);
        let objects = {
            "auditPageSize": auditPageSize,
            "auditPageNo": pageNumber,
            "auditSearch": auditSearch
        }
        dispatch(updateAuditPagination(objects));
    };

    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1);

    // };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearchSheet = (event: any) => {
        const { value } = event.target;
        setSearchTermSheet(value);
        setCurrentPagesheet(1);
    };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSize(Number(value));
    //     setCurrentPage(1);
    // };

    const handlePageSizeChangeSheet = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSizesheet(Number(value));
        setCurrentPagesheet(1);
    };

    // const filteredData: any = getFilteredList(Object.values(accountAuditList), searchTermSheet);
    // const indexOfLastItem = currentPagesheet * pageSizesheet;
    // const indexOfFirstItem = indexOfLastItem - pageSizesheet;
    // const sheetItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = accountAuditList.length;
    // const recordsFiltered = Object.values(filteredData).length;


    const filteredData: any =getFilteredList(Object.values(accountAuditList), searchTermSheet);
    const indexOfLastItem = auditPageNo * auditPageSize;
    const indexOfFirstItem = indexOfLastItem - auditPageSize;
     const sheetItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = Object.values(filteredData).length > 0 ? sortData( Object.values(filteredData) , sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem) : [];
    const totalItems = accountAuditList.length;
    const recordsFiltered = filteredData.length;
 


    const ExpenseEntryData: any = getFilteredList(expenseEntryList, search);
    const indexOfLastItemExpense = pageNo * pageSize;
    const indexOfFirstItemExpense = indexOfLastItemExpense - pageSize;
    const ExpenseEntryItems = ExpenseEntryData.slice(indexOfFirstItemExpense, indexOfLastItemExpense);
    const totalEntryItems = expenseEntryList.length;
    const recordsEntryFiltered = Object.values(ExpenseEntryData).length;

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleShowModal = (expenseentryId: any) => {
        setSelectedObject({ Id: expenseentryId, TableName: 'AccountExpenseEntry', Title: 'Expense Entry Audit' });
        dispatch(getAuditExpenseEntriesAsync({ TableName: 'AccountExpenseEntry', Id: expenseentryId }));
        setShowModal(true);
        setIsLoader(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
     
  
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            {isLoading ? <Loader />
            : <>
            <div className="card card-custom admin-card">
                <div className="card-header  card-drop-dr sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t(obj.Title)} */}
                        {getValueFromResource(obj.Title,dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTermSheet}
                                onChange={handleSearchSheet}
                                placeholder=
                                 {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                options={getPageSizeArray()}
                                value={getPageSizeArray().find((option: any) => option.value == pageSizesheet.toString())}
                                onChange={handlePageSizeChangeSheet}
                                className='fs-7 fw-normal'


                            /> */}
                         <PageSizeSelect onChange={handlePageSizeChangeSheet} />

                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(sheetItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPagesheet}
                                    onPageChange={handlePageChangeSheet}
                                    pageSize={pageSizesheet}
                                    totalItems={totalItems}
                                    start={(currentPagesheet - 1) * pageSizesheet}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                    </div>
                </div>
                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' >
                    <thead>
                        <tr className="thHeading align-middle " >
                        <th style={{ width: '20%'}}>
                            {/* {t('Updated Date')} */}
                            {getValueFromResource('Updated Date',dispatch, t)}
                            {sortColumn === 'UpdatedOn' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdatedOn") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdatedOn") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdatedOn") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdatedOn") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                            <th style={{ width: '20%'}}>
                                {/* {t('Field Name')} */}
                                {getValueFromResource('Field Name',dispatch, t)}
                            {sortColumn === 'FieldName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "FieldName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "FieldName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "FieldName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "FieldName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                            <th style={{ width: '20%'}}>
                                {/* {t('Old Value')} */}
                                {getValueFromResource('Old Value',dispatch, t)}
                            {sortColumn === 'OldValue' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "OldValue") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "OldValue") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "OldValue") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "OldValue") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                            <th style={{ width: '20%'}}>
                                {/* {t('New Value')} */}
                                {getValueFromResource('New Value',dispatch, t)}
                            {sortColumn === 'NewValue' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "NewValue") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "NewValue") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "NewValue") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "NewValue") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                            <th style={{ width: '20%'}}>
                                {/* {t('Update By')} */}
                                {getValueFromResource('Update By',dispatch, t)}
                            {sortColumn === 'UpdateBy' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdateBy") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdateBy") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "UpdateBy") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "UpdateBy") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        {sheetItems.length > 0 && sheetItems.map((auditList: any, i: any) => (
                            <tr key={i} style={{ height: 42 }}>
                                <td>
                                    {/* {moment(auditList.UpdatedOn).format('M-D-YYYY - h:mm A')} */}
                                    {formatCurrntDateTime(auditList.UpdatedOn, cultureInfoName.toString())}
                                </td>
                                <td>
                                    {/* {t(auditList.FieldName)} */}
                                   {getValueFromResource(auditList.FieldName, dispatch, t)}

                                </td>
                                <td>
                                    {/* {t(auditList.OldValue)} */}
                                    {auditList.FieldName.startsWith('Custom Field') ?
                                        getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.OldValue, customFieldsArrayForSheet, cultureInfoName.toString(), decimalPlaces) :
                                        formatAuditValue(
                                            auditList.OldValue,
                                            cultureInfoName,
                                            decimalPlaces,
                                            auditList.FieldName)}

                                </td>
                                <td>
                                    {/* {t(auditList.NewValue)} */}
                                    
                                    {auditList.FieldName.startsWith('Custom Field') ?
                                        getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.NewValue, customFieldsArrayForSheet, cultureInfoName.toString(), decimalPlaces) :
                                        formatAuditValue(
                                            auditList.NewValue,
                                            cultureInfoName,
                                            decimalPlaces,
                                            auditList.FieldName)}
                                </td>
                                <td >
                                    {/* {t(auditList.UpdateBy)} */}
                                   {getValueFromResource(auditList.UpdateBy, dispatch, t)}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {sheetItems.length === 0 &&
                  <div className=''>
                        <p className='noDataFound'>
                            {/* {t('No Record Found')} */}
                            {getValueFromResource('No Record Found',dispatch, t)}
                            </p>
                    </div>
                }

            </div>
            <br/>
            <div className="card card-custom admin-card">
                <div className="card-header card-drop-top sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Expense Entries')} */}
                        {getValueFromResource('Expense Entries',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                options={getPageSizeArray()}
                                value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'
                            /> */}
                        <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(ExpenseEntryItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalEntryItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsEntryFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                    </div>
                    </div>

                    <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                        <thead>
                            <tr className="thHeading align-middle " >
                            <th style={{ width: '20%'}}>
                                {/* {t('Expense Entry Data')} */}
                                {getValueFromResource('Expense Entry Data',dispatch, t)}
                                {sortColumn === 'AccountExpenseEntryDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseEntryDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseEntryDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseEntryDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseEntryDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                                <th style={{ width: '20%'}}>
                                    {/* {t('Expense Name')} */}
                                    {getValueFromResource('Expense Name',dispatch, t)}
                                {sortColumn === 'AccountExpenseName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                                <th style={{ width: '20%'}}>
                                    {/* {t('Project Name')} */}
                                    {getValueFromResource('Project Name',dispatch, t)}
                                {sortColumn === 'ProjectName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                                <th style={{ width: '15%' }}>
                                    {/* {t('Amount')} */}
                                    {getValueFromResource('Amount',dispatch, t)}
                                {sortColumn === 'Amount' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                                <th style={{ width: '20%', textAlign: 'center'}}>
                                    {/* {t('Status')} */}
                                    {getValueFromResource('Status',dispatch, t)}
                                {sortColumn === 'ApprovalStatus' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ApprovalStatus") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ApprovalStatus") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ApprovalStatus") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ApprovalStatus") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                                <th className='w-10 text-center'></th>
                            </tr>
                        </thead>
                        <tbody>

                            {ExpenseEntryItems.length > 0 && ExpenseEntryItems.map((expenseEntryDetail: any, i: any) => (
                                <tr key={i} style={{ height: 42 }}>
                                    <td>
                                        {/* {moment(expenseEntryDetail.AccountExpenseEntryDate).format('M-D-YYYY')} */}
                                        {formatDateWithDateAndMonthName(expenseEntryDetail.AccountExpenseEntryDate, cultureInfoName.toString())}
                                    </td>
                                    <td>
                                        {expenseEntryDetail.AccountExpenseName}
                                    </td>

                                    <td>
                                        <span className="fs-7"> {expenseEntryDetail.ProjectName}</span>
                                    </td>
                                    <td >
                                        <span className="fs-7">{expenseEntryDetail.CurrencyCode}  {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseEntryDetail.Amount, decimalPlaces)}</span>
                                    </td>

                                    <td className="fs-7 text-center">
                                        <span className="fs-7 text-center">  {expenseEntryDetail.ApprovalStatus} </span>
                                    </td>
                                    <td className='text-center'>
                                        <Dropdown
                                            style={{ marginLeft: 1 }}
                                            className={clsx('cursor-pointer symbol')}
                                            data-kt-menu-attach='parent'
                                            data-kt-menu-placement='bottom-end'
                                        >
                                            <Dropdown.Toggle
                                                variant="transparent"
                                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                data-tooltip-id="tooltip-Description"
                                                data-tooltip-content=
                                                // {t("More")}
                                                {getValueFromResource('More',dispatch, t)}
                                                data-tooltip-place="top"
                                            >
                                                <i className="bi bi-three-dots fs-7"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#expenseentryModal"
                                                            onClick={() => handleShowModal(expenseEntryDetail.AccountExpenseEntryId)}
                                                        >
                                                            <span className="menu-icon custom-menu mb-2">
                                                                <i className="bi bi-receipt fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Audit')}`} */}
                                                                {getValueFromResource('Audit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {ExpenseEntryItems.length === 0 &&
                        <div className=''>
                            <p className='noDataFound'>
                                {/* {t('No Record Found')} */}
                                {getValueFromResource('No Record Found',dispatch, t)}
                                </p>
                        </div>
                    }
               
            </div>
            </>
            }
            <div className="modal drawer-overlay" tabIndex={-1} data-bs-backdrop="false" id="expenseentryModal" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl' role="document">
                    <div className='modal-content rounded'>
                        <div className="modal-header">
                            <h6 className="modal-title">
                                {/* {t('Expense Entries Audit')} */}
                                {getValueFromResource('Expense Entries Audit',dispatch, t)}
                                </h6>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>

                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                        {isLoader ? <CanvasLoader/> : <>
                            <div className="table-responsive">
                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ marginLeft: '10px' }}>
                                    <thead>
                                        <tr className="thHeading align-middle " >
                                            <th className='w-20' >
                                                {/* {t('Updated Date')} */}
                                                {getValueFromResource('Updated Date',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('Field Name')} */}
                                                {getValueFromResource('Field Name',dispatch, t)}
                                                </th>
                                            <th className='w-20'> 
                                                {/* {t('Old Value')} */}
                                                {getValueFromResource('Old Value',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('New Value')} */}
                                                {getValueFromResource('New Value',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('Update By')} */}
                                                {getValueFromResource('Update By',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {expenseAuditList.length > 0 && expenseAuditList.map((auditList: any, i: any) => (
                                            <tr key={i} style={{ height: 42 }}>
                                                <td>
                                                    {/* {moment(auditList.UpdatedOn).format('M-D-YYYY - h:mm A')} */}
                                                    {formatCurrntDateTime(auditList.UpdatedOn, cultureInfoName.toString())}
                                                </td>
                                                <td>
                                                    {auditList.FieldName}
                                                </td>
                                                <td>
                                                    {auditList.FieldName.startsWith('Custom Field') ?
                                                        getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.OldValue, customFieldsArray, cultureInfoName.toString(), decimalPlaces) :
                                                        formatAuditValue(
                                                            auditList.OldValue,
                                                            cultureInfoName,
                                                            decimalPlaces,
                                                            auditList.FieldName)}
                                                    {/* {auditList.OldValue} */}
{/*                                                     {auditList.FieldName === "Created On" ?
                                                    formatCurrntDateTime(auditList.OldValue, cultureInfoName.toString()) :
                                                    auditList.FieldName === "Account Expense Entry Date" || auditList.FieldName === "End Date" || auditList.FieldName === "Approved On" ?
                                                        formatDateWithDateAndMonthName(auditList.OldValue, cultureInfoName.toString())
                                                        : auditList.FieldName === "Rate" || auditList.FieldName === "Amount Before Tax" || auditList.FieldName === "Amount" && !isNaN(parseFloat(auditList.OldValue)) ?
                                                            FormatInvoiceDecimalNumber(cultureInfoName.toString(), auditList.OldValue, decimalPlaces)
                                                            : getValueFromResource(auditList.OldValue, dispatch, t)} */}
                                                </td>
                                                <td >
                                                    {auditList.FieldName.startsWith('Custom Field') ?
                                                        getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.NewValue, customFieldsArray, cultureInfoName.toString(), decimalPlaces) :
                                                        formatAuditValue(
                                                            auditList.NewValue,
                                                            cultureInfoName,
                                                            decimalPlaces,
                                                            auditList.FieldName)}
                                                    {/* {auditList.NewValue} */}
{/*                                                     {auditList.FieldName === "Created On" ?
                                                    formatCurrntDateTime(auditList.NewValue, cultureInfoName.toString()) :
                                                    auditList.FieldName === "Account Expense Entry Date" || auditList.FieldName === "End Date" || auditList.FieldName === "Approved On" ?
                                                        formatDateWithDateAndMonthName(auditList.NewValue, cultureInfoName.toString())
                                                        : auditList.FieldName === "Rate" || auditList.FieldName === "Amount Before Tax" || auditList.FieldName === "Amount" && !isNaN(parseFloat(auditList.NewValue)) ?
                                                            FormatInvoiceDecimalNumber(cultureInfoName.toString(), auditList.NewValue, decimalPlaces)
                                                            : getValueFromResource(auditList.NewValue, dispatch, t)} */}
                                                </td>
                                                <td>
                                                    {auditList.UpdateBy}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {(!Array.isArray(expenseAuditList) || expenseAuditList.length === 0) && (
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                )}
                            </div>
                            </>
                         }
                        </div>
                        <div className="modal-footer"  >
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm me-2"
                                data-bs-dismiss="modal"
                            >
                              {/* {t('Cancel')}   */}
                              {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default ExpenseAudit